function convertDelisleToCelsius(num) {
  let eq =
    "Converting " +
    num +
    "° delisle to celsius: \n" +
    "100 - " +
    num +
    " * 2 / 3 = ";
  let rep = 100 - (num * 2) / 3;
  return eq + rep.toFixed(2);
}

function convertDelisleToFahrenheit(num) {
  let eq =
    "Converting " +
    num +
    "° delisle to fahrenheit: \n" +
    "212 - " +
    num +
    " * 6/5 = ";
  let rep = 212 - (num * 6) / 5;
  return eq + rep.toFixed(2);
}

function convertDelisleToKelvin(num) {
  let eq =
    "Converting " +
    num +
    "° delisle to kelvin:  \n" +
    "373.15 - " +
    num +
    " * 2 / 3 = ";
  let rep = 373.15 - (num * 2) / 3;
  return eq + rep.toFixed(3);
}

function convertDelisleToRankine(num) {
  let eq =
    "Converting " +
    num +
    "° delisle to rankine: \n" +
    "671.67 - " +
    num +
    " * 6 / 5 = ";
  let rep = 671.67 - (num * 6) / 5;
  return eq + rep.toFixed(3);
}

function convertDelisleToNewton(num) {
  let eq =
    "Converting " +
    num +
    "° delisle to newton: \n" +
    "33 - " +
    num +
    " * 11 / 50 = ";
  let rep = 33 - (num * 11) / 50;
  return eq + rep.toFixed(2);
}

function convertDelisleToRéaumur(num) {
  let eq =
    "Converting " +
    num +
    "° delisle to réaumur: \n" +
    "80 * " +
    num +
    " * 8 / 15 = ";
  let rep = (80 * num * 8) / 15;
  return eq + rep.toFixed(2);
}

function convertDelisleToRømer(num) {
  let eq =
    "Converting " +
    num +
    "° delisle to rømer: \n" +
    "60 - " +
    num +
    " * 7 / 20 = ";
  let rep = 60 - (num * 7) / 20;
  return eq + rep.toFixed(2);
}

export {
  convertDelisleToCelsius,
  convertDelisleToRømer,
  convertDelisleToRéaumur,
  convertDelisleToNewton,
  convertDelisleToRankine,
  convertDelisleToKelvin,
  convertDelisleToFahrenheit
};
